import { render, staticRenderFns } from "./TvAppCard.vue?vue&type=template&id=c925e7c8"
import script from "./TvAppCard.vue?vue&type=script&lang=js"
export * from "./TvAppCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports